import $ from 'jquery';
import BaseUploadView from '../../pages/fttc2/BaseUploadView';

export default BaseUploadView.extend({

    events: {
        'change input.fileUploadField': 'onUploadInputChanged',
        'click .js-file-remove': 'onFileRemoveClicked'
    },

    $boxLeft: null,
    $boxRight: null,

    $uploadTemplate: null,

    messageBox: null,

    initialize: function (options) {
        this.$uploadTemplate = options.$uploadTemplate;
        this.messageBox = options.messageBox;
        this.setBoxesHeight();
    },

    getUploadContainer: function () {
        return this.$el;
    },

    prepareUploadManager: function (uploadManager, event) {
        uploadManager.$scope = this.$el;

        uploadManager
            .setForm(this.$('.fttc2-upload-form').first())
            .setInput($(event.currentTarget))
            .validate();
    },

    /**
     * Event handler that start file upload process
     * @param event
     */
    onUploadInputChanged: function (event) {
        event.preventDefault();
        if (event.currentTarget.value) {
            this.startUpload(event);
        }
        event.currentTarget.value = '';
    },

    postInsertTemplate: function () {
        this.setBoxesHeight();
    },

    postUploadSuccess: function () {
        this.setBoxesHeight();
    },

    postUploadFailure: function () {
        this.setBoxesHeight();
    },

    /**
     * Method is executed after uploaded file has been deleted from view
     */
    postFileRemove: function () {
        this.setBoxesHeight();
    },

    updateModelFromView: function () {
        if (this.$el.length > 0) {
            this.model.set({
                comment: this.$el.find('#reclamationComment').val()
            });
        }
    },

    setBoxesHeight: function () {
        var heightLeft;
        var heightRight;
        var newHeight;

        if (!this.$boxLeft) {
            this.$boxLeft = this.$('#box-left');
        }
        if (!this.$boxRight) {
            this.$boxRight = this.$('#box-right');
        }

        this.$boxRight.css('height', 'auto');
        this.$boxLeft.css('height', 'auto');

        heightLeft = this.$boxLeft.height();
        heightRight = this.$boxRight.height();

        if (heightLeft > heightRight) {
            newHeight = heightLeft;
        } else {
            newHeight = heightRight;
        }

        this.$boxRight.height(newHeight);
        this.$boxLeft.height(newHeight);

        this.$boxLeft.find('textarea').height(newHeight - (this.$boxLeft.find('p').outerHeight() * 2));

    }

});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/pages/fttc2/Step1UploadView.js
 **/